import { use } from "react";

export const grokMandatoryOptions = [
    {
        key: "GrokConversations",
        name: "GrokConversations",
        title: "Grok conversations",
        description: "All conversations you’ve had in the Grok chatbot.",
        optionPlatform: "grok",
        essential: true,         
        payment: "+$5.0",
        type: "standard",
        parent: null,
        use: null,
        warning: "These conversations may contain sensitive personal information. We strongly recommend checking the archive before donation to better understand what you are donating."
    },

]; 

export const grokOptionalOptions = [
    {
        key: 'GrokProjects', 
        name: 'GrokProjects',
        title: 'Grok projects',
        description: 'Projects you have created in Grok, including project names, descriptions, and associated conversations.',
        optionPlatform: 'grok',
        essential: false,
        payment: '+$1.0',
        type: 'standard',
        parent: null,
        use: null, 
        warning: null,
    },
    {
        key: 'GrokTasks', 
        name: 'GrokTasks', 
        title: 'Grok tasks',
        description: 'Tasks you have created in Grok, including task names, descriptions, and their associated prompts.',
        optionPlatform: 'grok',
        essential: false,
        payment: '+$1.0',
        type: 'standard',
        parent: null,
        use: null, 
        warning: null
    }, 
    {
        key: 'GrokMediaPosts', 
        name: 'GrokMediaPosts',
        title: 'Grok media posts',
        description: 'Media posts you have created on the Grok.com "Imagine" tab.',
        optionPlatform: 'grok',
        essential: false,
        payment: '+$1.0',
        type: 'standard',
        parent: null,
        use: null, 
        warning: null
    }
]; 

export const grokExcludedOptions  = [
    {

    }


]; 